export default __webpack_public_path__ + "static/media/modal-close.251dad37.svg";